import { formatMoney, stripHtmlTags } from './custom-utilities.js';
//
if (!customElements.get("custom-builder")) {
  customElements.define(
    "custom-builder",
    class CustomBuilder extends HTMLElement {
      static STATES = Object.freeze({
        'active' : 'active',
        'loading': 'loading',
        'caution': 'caution',
        'pending': 'pending'
      });

      #current;
      #cache = new Map();
      #proxy;
      #commands = Object.freeze({
        "get" : Object.freeze({
          "find" : (target, value) => {
            return Object.entries(target).find(([_, v]) => v === value)?.[0];
          },
          "has" : (target, value) => {
            return Object.values(target).includes(value);
          },
          "valuesArray"  : (target) => [...Object.values(target)],
          "keysArray"    : (target) => [...Object.keys(target)], 
          "entriesArray" : (target) => [...Object.entries(target)], 
        })
      });

      constructor() {
        super();
        this.attachShadow({ mode:'open' });
      }
      
      connectedCallback() {
        //Appry Style
        const link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('href', this.dataset.styleurl); // Light DOM で使っていたCSSパス
        this.shadowRoot.appendChild(link);

        //Load template to shadowDOm
        const template = this.nextElementSibling;
        if (template && template.tagName === 'TEMPLATE') {
          const clone = template.content.cloneNode(true);
          this.shadowRoot.appendChild(clone);
        } else {
          console.warn('<template> not found after <my-element>');
        }

        //Local scope variables
        let touchStart, touchCurrent;

        //Member Variables
        this.sectionid = this.dataset.sectionid;
        this.product = {
          "id" : this.dataset.productid,
          "title" : this.dataset.producttitle,
          "price" : Number(this.dataset.productprice)
        };
        this.currency = {
          "code" : this.dataset.currencycode,
          "symbol" : this.dataset.currencysymbol,
          "value" : Number(this.dataset.currentprice)
        };
        this.local = this.dataset.localisocode;

        this.list = this.generateBuilderList(this.dataset.builderlist);

        this.#proxy = new Proxy(Object.fromEntries(this.list.entries()), {
          get : (target, key, proxy) => {
            if (key in this.#commands.get) {
              return (value) => this.#commands.get[key](target, value);
            }
            return Reflect.get(target, key, proxy);
          },
          set : (target, key, value, proxy) => {
            Reflect.set(target, key, value, proxy);
            this.list.set(key, Reflect.get(target, key, proxy));
            if (value != null) {
              this.setResultItem(key, value);
            } else {
              this.resetResultItem(key);
            }

            this.style.setProperty('--cart-item-count', `"${this.countCartItems()}"`);

            return true;
          },
        });

        this.setCurrent(Array.from(this.list.keys())[0]);

        this.stage       = this.shadowRoot.querySelector('.custom-builder');
        this.wrapper     = this.shadowRoot.querySelector('.custom-builder-trigger-wrapper');
        this.trigger     = this.shadowRoot.querySelector('input[name="is-building"]');
        this.menu        = this.shadowRoot.querySelector('.builder-header.navigation');

        //this.select extend child node
        this.select = this.shadowRoot.querySelector('.builder-list-container');
        Object.assign(this.select, Object.freeze({
          'node' : Object.freeze({
            'inner'  : this.select.querySelector('.inner'),
            'total'  : this.select.querySelector('.total-price'),
            'submit' : this.select.querySelector('button.all-submit'),
          })
        }))

        //this.detail extend child node
        this.detail = this.shadowRoot.querySelector('.description-container');
        Object.assign(this.detail, Object.freeze({
          'node' : Object.freeze({
            'image'       : this.detail.querySelector('.image-grid'),
            'title'       : this.detail.querySelector('h3.title'),
            'price'       : this.detail.querySelector('div.price'),
            'description' : this.detail.querySelector('div.description'),
            'submit'      : this.detail.querySelector('button[value="add"]'),
            'max'         : this.detail.querySelector('span.max'),
            'prev'        : this.detail.querySelector('button[value="prev"]'),
            'next'        : this.detail.querySelector('button[value="next"]')
          })
        }));

        this.error  = this.shadowRoot.querySelector('.error-container');
        Object.assign(this.error, Object.freeze({
          'node' : Object.freeze({
            'list' : this.error.querySelector('.description>.item-list'),
          })
        }))


        //Event Register
        this.trigger.addEventListener('change', e => {
          this.toggle(this.stage, e.target.checked, CustomBuilder.STATES.active)

          this.dispatchEvent(new CustomEvent('custom-builder-scroll-lock', {
            bubbles: true,
            composed: true,
            detail: { lock: e.target.checked }
          }));              
        });

        [...this.shadowRoot.querySelectorAll('.navigation input[type="radio"]')].forEach(radio => radio.addEventListener('change', this.selectMenu));
        [...this.shadowRoot.querySelectorAll('input.builder-item')].forEach(radio => radio.addEventListener('change', this.selectItem));
        [...this.shadowRoot.querySelectorAll('button')].forEach(button => button.addEventListener('click', this.clickButton));

        this.detail.node.image.addEventListener('touchstart', e => {
          touchStart = e.touches ? e.touches[0].clientX : e.clientX;
        });
        this.detail.node.image.addEventListener('touchmove', e => {
          touchCurrent = e.touches ? e.touches[0].clientX : e.clientX;
        });
        this.detail.node.image.addEventListener('touchend', () => {
          const moveMount = Math.abs(touchCurrent - touchStart);
          
          if (moveMount < 50) return false;

          if (touchCurrent < touchStart) {
            this.imageCaroucelRight(this.detail.node.next);
          } else {
            this.imageCaroucelLeft(this.detail.node.prev);
          }
        });

        setTimeout(() => {
          this.toggle(this.wrapper, false, CustomBuilder.STATES.pending);
        }, 1500);
      }

      /* --------------
       * EVENT CALLBACK
       * --------------
       */

      clickButton = e => {
        const button = e.target.closest('button');
        if (!button || !this.shadowRoot.contains(button)) return;

        const action = button.value;

        const actionMap = {
          "evacuate": () => this.evacuate(),
          "retry":    () => this.retry(),
          "close":    () => this.close(),
          "hide":     () => this.hide(),
          "back":     () => this.back(),
          "cart":     () => this.checkCart(),
          "prev":     () => this.imageCaroucelLeft(button),
          "next":     () => this.imageCaroucelRight(button),
          "add":      () => this.addItem(button.dataset.id),
          "delete":   () => this.deleteItem(button.dataset.group),
          "check":    () => this.showSelectedItem(button.dataset.id, button.dataset.group),
          "submit":   () => this.submitAll(),
        };

        if (actionMap[action]) {
          actionMap[action](); // 対応する処理を実行
        } else {
          console.warn('NO BUTTON ACTION:', action);
        }
      }

      //select item
      selectItem = e => {
        if (e.target.checked == true) {
          e.target.checked = false;
          const routes = {
            "group"    : e.target.dataset.group,
            "field"    : e.target.dataset.field,
            "category" : e.target.dataset.category
          };
          if (e.target.dataset.group != false) {
            this.setCurrent(e.target.dataset.group);
          }
          this.toggle(this.stage, true, CustomBuilder.STATES.loading);
          this.getProduct(e.target.value, e.target.dataset.id, routes);
        }
      }
      
      //select menu
      selectMenu = e => {
        const value = e.target.value;
        const target = this.shadowRoot.querySelector(`.${value}`);

        if (target != null) {
          this.setCurrent(value);
          this.stage.scrollTop = 0;
          [...target.parentElement.children].forEach(node => {
            this.toggle(node, node == target, CustomBuilder.STATES.active);
          });
        }
      }

      initialize() {
      }

      evacuate() {
        if (this.wrapper.classList.contains(CustomBuilder.STATES.active) === true) {
          this.toggle(this.wrapper, false, CustomBuilder.STATES.active);
        } else {
          this.toggle(this.wrapper, true, CustomBuilder.STATES.active);
        }
      }

      close() {
        this.trigger.checked = false;
        this.trigger.dispatchEvent(new Event('change'));
      }
      hide () {
        this.toggle(this.detail, false, CustomBuilder.STATES.active);
        this.toggle(this.stage, false, CustomBuilder.STATES.loading);
      }
      back() {
        this.toggle(this.select, false, CustomBuilder.STATES.active);
        this.toggle(this.stage, false, CustomBuilder.STATES.loading);
      }
      retry() {
        this.select.node.inner.scrollTop = 0;
        this.toggle(this.error, false, CustomBuilder.STATES.active);
        this.toggle(this.select, true, CustomBuilder.STATES.active);
      }

      imageCaroucelLeft(button) {
        button.disabled = true;

        let index = Number(this.detail.node.image.dataset.index);
        //
        if (--index < 0) {
          index = 0;
        }
        //
        this.detail.node.image.dataset.index = index;
        this.style.setProperty('--images-slide-index', index);
        this.style.setProperty('--images-slide-label', `"${index+1}"`);
        //
        this.detail.node.next.disabled = false;
        if (0 < index) {
          button.disabled = false;
        }
      }

      imageCaroucelRight(button) {
        button.disabled = true;

        const right = Number(this.detail.node.image.dataset.count);

        let index = Number(this.detail.node.image.dataset.index);
        //
        if (right <= ++index) {
          index = right-1;
        }
        //
        this.detail.node.image.dataset.index = index;
        this.style.setProperty('--images-slide-index', index);
        this.style.setProperty('--images-slide-label', `"${index+1}"`);
        //
        this.detail.node.prev.disabled = false;
        if (index < right-1) {
          button.disabled = false;
        }
      }

      submitAll() {
        if (this.isCompleted() == true) {
          const itemList =this.generateItemList();
          this.toggle(this.select, false, CustomBuilder.STATES.active);
          this.addCart(itemList);
        }
      }

      countCartItems() {
        return this.#proxy.valuesArray().reduce((a, c) => c !== null ? ++a : a, 1);
      }

      checkCart() {
        this.select.node.inner.scrollTop = 0;
        this.toggle(this.stage, true, CustomBuilder.STATES.loading);
        this.toggle(this.select, true, CustomBuilder.STATES.active);
      }

      addItem(value) {
        if (value == null || this.#current == null) return;

        if (this.#proxy[this.#current] != false) {
          [...this.stage.querySelectorAll(`.builder-item-${this.#proxy[this.#current]}`)].forEach(item => {
            this.toggle(item, false, CustomBuilder.STATES.active);
          });
        }

        this.#proxy[this.#current] = value;

        [...this.stage.querySelectorAll(`.builder-item-${this.#proxy[this.#current]}`)].forEach(item => {
          this.toggle(item, true, CustomBuilder.STATES.active);
        });

        this.toggle(this.detail, false, CustomBuilder.STATES.active);
        this.select.node.submit.disabled = this.setNext();

        if (this.select.node.submit.disabled) {
          this.toggle(this.stage, false, CustomBuilder.STATES.loading);
        } else {
          this.toggle(this.select, true, CustomBuilder.STATES.active);
        }

      }

      deleteItem(group) {
        if (group == null) return;

        if (this.#proxy[group] != false) {
          [...this.stage.querySelectorAll(`.builder-item-${this.#proxy[group]}`)].forEach(item => {
            this.toggle(item, false, CustomBuilder.STATES.active);
          });
        }

        this.#proxy[group] = null;

        this.toggle(this.select, false, CustomBuilder.STATES.active);
        this.select.node.submit.disabled = this.setNext();
        this.toggle(this.stage, false, CustomBuilder.STATES.loading);
      }

      async addCart(items) {
        if (!Array.isArray(items) || items.length === 0) {
          console.warn('商品リストが空です。');
          return;
        }

        try {
          const response = await fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`${errorData.description}`);
          }

          this.toggle(this.stage, false, CustomBuilder.STATES.loading);
          this.toggle(this.wrapper, true, CustomBuilder.STATES.pending);
          this.close();
          window.location.href = '/cart';

        } catch (error) {
          this.cartErrorHandling(error);
        }
      }

      cartErrorHandling(_error) {
        const cartList = this.getCartList();
        cartList.then(result => {
          let errorItemList = {
            'html' : '',
            'list' : []
          };
          if (0 < result.item_count) {
            const currentList = this.#proxy.valuesArray();
            errorItemList = result.items.reduce((a, c) => {
              if (currentList.includes(`${c.variant_id}`) == true) {
                a.html = `${a.html}<li class="item-title"><strong>${c.product_type.toUpperCase()}</strong>${c.product_title}</li>`;
                a.list.push(c.variant_id);
              }
              return a;
            }, errorItemList);
          }
          this.error.node.list.innerHTML = errorItemList.html;
          errorItemList.list.forEach(id => {
            const group = this.#proxy.find(id) || this.#proxy.find(`${id}`);
            if (group !== undefined) {
              const target = this.select.querySelector(`.builder-result-${group}`);
              this.toggle(target, true, CustomBuilder.STATES.caution);
            }
          });
          this.toggle(this.error, true, CustomBuilder.STATES.active);
        }).catch(error => {
          console.error(error);
        });
      }

      isCompleted() {
        return this.#proxy.valuesArray().reduce((a,c) => a && c !== null);
      }

      generateItemList() {
        const itemList = this.#proxy.valuesArray().map(value => {
          return {
            id: value,
            quantity: 1,
            properties: {
              note: `COMPLETE/${this.product.title}`
            }
          }
        });
        return [
        { id: this.product.id, quantity: 1 },
        ...itemList
        ];
      }

      generateBuilderList(raw) {
        try {
          const labels = JSON.parse(raw);
          return new Map(labels.map(label => [label, null]));
        } catch (err) {
          console.error('Invalid builderlist JSON:', raw, err);
          return new Map(); // fallback
        }
      }

      setNext() {
        const current = this.menu.querySelector(`input[value="${this.#current}-${this.sectionid}"]`);
        const radios  = [...this.menu.querySelectorAll(`input[name="${current.name}"]`)];
        const entries = this.#proxy.entriesArray();
        
        for(const [i, [, v]] of entries.entries()) {
          if (v == null) {
            const next = radios[i];
            next.checked = true;
            next.dispatchEvent(new Event('change'));
            return true;
          }
        }
        return false;
      }

      setCurrent(key) {
        if (this.list.has(key) == true) {
          this.#current = key;
        }
        return this.#current;
      }

      setResultItem(key, value) {
        const target = this.select.querySelector(`.builder-result-${key}`);
        const data = this.#cache.has(value) ? this.#cache.get(value) : null;

        if (target != null && data != null) {
          const product = target.querySelector('button.builder-item');
          product.dataset.id = value;
          product.disabled = false;
          product.querySelector('img.thumbnail').setAttribute('src', data.images[0]);
          target.querySelector('h5.item-title').innerHTML = data.title;
          target.querySelector('p.item-price').innerHTML = this.getPrice(data.price);
          target.querySelector('button.delete').disabled = false;

          this.select.node.total.textContent = this.getTotalPrice();
          this.select.querySelector('.inner').scrollTop = 0;

          this.toggle(target, false, CustomBuilder.STATES.caution);
        }
      }

      resetResultItem(key) {
        const target = this.select.querySelector(`.builder-result-${key}`);

        if (target != null) {
          const product = target.querySelector('button.builder-item');
          product.dataset.id = "";
          product.disabled = true;
          product.querySelector('img.thumbnail').setAttribute('src', "");
          target.querySelector('h5.item-title').innerHTML = "";
          target.querySelector('p.item-price').innerHTML = "";
          target.querySelector('button.delete').disabled = true;

          this.select.node.total.textContent = this.getTotalPrice();
          this.select.querySelector('.inner').scrollTop = 0;

          this.toggle(target, false, CustomBuilder.STATES.caution);
        }
      }

      showSelectedItem(id, group) {
        if (this.#cache.has(id) == true && this.list.has(group) == true) {
          this.setCurrent(group);
          this.setProductDetail(this.#cache.get(id));
          this.activateDetail();
        }
      }

      async getCartList() {
        try {
          const res  = await fetch('/cart.js');
          const data = await res.json();
          
          return data;
        } catch(_e) {
          return null;
        }
      }

      async getProduct(handle, id, routes) {
        if (!handle) return false;

        if (this.#cache.has(id) == true) {
          this.setProductDetail(this.#cache.get(id));
          this.activateDetail();
          return true;
        }

        try {
          const api = `/products/${handle}.js`;
          const res = await fetch(api);
          const data = await res.json();

          if (this.#cache.has(id) == false) {
            this.#cache.set(id, Object.freeze({
              'handle': data.handle,
              'title' : data.title,
              'images': data.images,
              'price' : data.price,
              'variants' : data.variants,
              'description': data.description,
              'routes': routes
            }));
          }

          this.setProductDetail(this.#cache.get(id));
          this.activateDetail();

        } catch (e) {
          console.error(e);
        }
      }

      productImageLoad = () => {
        this.detail.firstElementChild.scrollTop = 0;
        requestAnimationFrame(() => this.toggle(this.detail, true, CustomBuilder.STATES.active));
      }

      activateDetail() {
        const images = [...this.detail.node.image.querySelectorAll('img')];

        if (images.length == 0) return false;

        this.observeImagesLoaded(images);
      }

      async observeImagesLoaded(images) {
        await Promise.all(
          images.map(img => {
            if (img.complete && img.naturalHeight !== 0) {
              return Promise.resolve();
            }
            return new Promise((res, rej) => {
              img.addEventListener('load', res, { once: true });
              img.addEventListener('error', rej, { once: true });
            });
          })
        );
        this.productImageLoad();
      }

      toggle(target, flag, value) {
        if (flag) {
          if (target.classList.contains(value) == false) {
            target.classList.add(value);
          }
        } else {
          if (target.classList.contains(value) == true) {
            target.classList.remove(value);
          }
        }
      }

      setProductDetail(data) {
        let state = false;
        let label = 'SELECT';

        if (this.#current != null && this.#proxy[this.#current] != null && this.#proxy[this.#current] == data.variants[0].id) {
          state = true;
          label = 'SELECTED';
        }

        //images
        this.detail.node.image.style.width = `${data.images.length * 100}%`;
        this.detail.node.image.innerHTML = data.images.reduce((a, c) => `${a}<div class="image-grid-cell"><img src="${c}"></div>`, '');
        this.detail.node.image.dataset.index = 0;
        this.detail.node.image.dataset.count = data.images.length;
        this.style.setProperty('--images-slide-index', 0);
        this.style.setProperty('--images-slide-label', '"1"');
        this.style.setProperty('--images-slide-count', data.images.length);

        //contoroller
        this.detail.node.max.innerHTML = data.images.length;
        this.detail.node.prev.disabled = true;
        this.detail.node.next.disabled = !(1 < data.images.length);

        //title
        this.detail.node.title.innerHTML = data.title;

        //price
        this.detail.node.price.innerHTML = this.getPrice(data.price);

        //description
        this.detail.node.description.innerHTML = stripHtmlTags(data.description);

        //submit
        this.detail.node.submit.dataset.id = data.variants[0].id;
        this.detail.node.submit.disabled = state;
        this.detail.node.submit.innerHTML = label;
      }

      getPrice(price) {
        const formated = formatMoney(price, 'amount_no_decimals');
        return `${this.currency.symbol}${formated} ${this.currency.code}`;
      }

      getTotalPrice() {
        const total =  this.#proxy.valuesArray().reduce((a, c) => {
          let price = 0;
          if (this.#cache.has(c) == true) {
            price = this.#cache.get(c).price;
          }
          return a + price;
        }, this.product.price);
        return this.getPrice(total);
      }
    }
  );
}
